module.exports = __webpack_public_path__ + "2a2ab519c704dcf0c8b96c433e51be55.jpg";